import React from 'react';
import { Link } from 'react-router-dom';

const OmOs = () => {
  return (
    <div className="pt-20">
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
        <img 
          src="/media/EDIT/IMG_2281EDIT.jpeg" 
          alt="Background" 
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        
        <div className="relative z-10 text-center text-white px-4 max-w-3xl mx-auto py-20">
          <div className=" bg-opacity-100 rounded-3xl p-8 md:p-12 shadow-2xl">
            <h1 className="text-4xl md:text-5xl font-bold uppercase mb-6 text-shadow-strong">
              Murermester Voss
            </h1>
            
            <p className="text-lg md:text-xl leading-relaxed font-bold text-shadow-strong">
              Jeg er din lokale ekspert inden for alt murerarbejde
              <br />
              – med særligt fokus på badeværelser og renovering.
              <br /><br />
              Hos mig er kvalitet og godt håndværk altid i højsædet!
              <br /><br />
              Har du et projekt i tankerne? Kontakt mig i dag, og få et uforpligtende tilbud.
              <br /><br />
              Sammen skaber vi løsninger, der holder 💪
            </p>
          </div>

          <div className="mt-8">
            <Link to="/kontakt">
              <button className="btn-primary text-xl px-8 py-4">KONTAKT</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OmOs;
